export const getValue = (value: string | null): string => {
  if (!value) return "";
  return value.replace(/^"(.*)"$/, "$1");
};
